
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tyres",
      function () {
        return require("private-next-pages/tyres/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tyres"])
      });
    }
  